import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbNavModule, NgbAccordionModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

// Swiper Slider
import { SlickCarouselModule } from 'ngx-slick-carousel';

// Counter
import { CountUpModule } from 'ngx-countup';

import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { TitleCasePipe } from './pipes/title-case.pipe';
import { FiltroGenericoPlanesComponent } from './filtro-generico-planes/filtro-generico-planes.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ActivarInactivarIconoComponent } from './activar-inactivar-icono/activar-inactivar-icono.component';
import { ActivarInactivarOptionComponent } from './activar-inactivar-option/activar-inactivar-option.component';


@NgModule({
  declarations: [
    BreadcrumbsComponent,
    TitleCasePipe,
    FiltroGenericoPlanesComponent,
    ActivarInactivarIconoComponent,
    ActivarInactivarOptionComponent
  ],
  imports: [
    CommonModule,
    NgbNavModule,
    NgbAccordionModule,
    NgbDropdownModule,
    SlickCarouselModule,
    CountUpModule,
    ReactiveFormsModule
  ],
  exports: [BreadcrumbsComponent, TitleCasePipe, FiltroGenericoPlanesComponent, ActivarInactivarIconoComponent, ActivarInactivarOptionComponent]
})
export class SharedModule { }
